import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A6DataUploadTable } from "./table";
import { A6DataUploadEdit } from "./edit";

export default function A6DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Chargement de fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A6DataUploadEdit />} />
      <Route index element={<A6DataUploadTable />} />
    </Routes>
  );
}
